<template>
  <div class="content">
    <Header :title="'个人设置'" />
    <div class="wrap-form">
      <ul>
        <li>
          <span class="my-lable">头 像</span>
          <div class="avator-img">
            <van-uploader
              :max-count="1"
              :before-read="beforeRead"
              :after-read="afterRead"
              :max-size="1024 * 1024 * 5"
              :preview-image="true"
              :show-upload="true"
              @oversize="onOversize"
            >
              <div class="img-wrap">
                <img :src="$resUrl(headPicture)" alt @error="$defImg(require('@/assets/images/avatar-default.png'))">
              </div>
            </van-uploader>
          </div>
          <i class="iconfont icon-right">&#xe655;</i>
        </li>
        <li>
          <nut-textinput
            v-model="form.nickName"
            type="text"
            label="昵称"
            placeholder="请输入昵称"
            :disabled="false"
            :has-border="false"
            maxlength="20"
            @blur="onBlurNick"
          />
        </li>
        <li>
          <nut-textinput
            v-model="form.name"
            type="text"
            label="姓名"
            placeholder="请输姓名"
            :disabled="false"
            :has-border="false"
            maxlength="20"
            @blur="onBlur"
          />
        </li>
        <li>
          <span class="my-lable">性别</span>
          <nut-radiogroup v-model="form.gender" size="base">
            <nut-radio label="Man">男</nut-radio>
            <nut-radio label="Woman">女</nut-radio>
            <nut-radio label="Secret">保密</nut-radio>
          </nut-radiogroup>
        </li>
        <li class="my-age">
          <label class="my-lable">年龄</label>
          <div class="my-lable-content">
            <input v-model="form.age" class="txt-age" type="number" placeholder="请输入年龄">
          </div>
        </li>
        <li>
          <nut-textinput
            v-model="form.job"
            type="text"
            label="职业"
            placeholder="职业"
            :disabled="false"
            :has-border="false"
          />
        </li>
        <li class="not-edit">
          <label class="my-lable">手机号码</label>
          <p class="my-lable-content">
            <span>{{ phone | empty }}</span>
          </p>
        </li>
        <li class="role not-edit">
          <label class="my-lable">角色</label>
          <p class="my-lable-content">
            <span>{{ role | empty }}</span>
          </p>
          <nut-row
            v-show="form.memberLevelId === 3"
            type="flex"
            justify="space-between"
            style="width: 100%; float: left"
          >
            <nut-col :span="11">
              <nut-button block @click="applySalesman">申请成为业务员</nut-button>
            </nut-col>
            <nut-col :span="11">
              <nut-button block @click="applyFranchisee">申请成为加盟商</nut-button>
            </nut-col>
          </nut-row>
        </li>
        <li class="not-edit">
          <span class="my-lable">地址</span>
          <p class="area">
            <span>{{ province || '- 省' }}</span>
            <span>{{ city || '- 市' }}</span>
            <span>{{ area || '- 区' }}</span>
          </p>
        </li>
        <li>
          <nut-textinput
            v-model="form.address"
            type="text"
            label
            placeholder="请输入详细地址"
            :disabled="false"
            :has-border="false"
          />
        </li>
      </ul>
    </div>

    <div class="btn-wrap">
      <nut-button block shape="circle" @click="btnOnConfirm">提 交</nut-button>
    </div>
    <Footer :active="4" />
  </div>
</template>
<script>
import Vue from 'vue'
import { Uploader } from 'vant'
import { baseInfo, uploadAvatarImg, edit, joinSalesman, setAvatar } from '@/api/Personal/index'
import { Toast } from '@nutui/nutui'
import city from '@/assets/js/city'
import Storage from '@/utils/storage'
import Header from '@/components/Header/Index'
import Footer from '@/components/Footer/Index'

Vue.use(Uploader)

export default {
  name: 'Setting',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      showPicker: false,
      columns: city,
      province: '',
      city: '',
      area: '',
      isRequest: true,
      isRequestApplySalesman: true,
      phone: '',
      role: '',
      headPicture: require('@/assets/images/avatar-default.png'),

      form: {
        nickName: '',
        memberLevelId: 3,
        name: '',
        age: 0,
        gender: 'Man',
        job: '',
        headPicture: require('@/assets/images/avatar-default.png'),
        provinceId: 0,
        cityId: 0,
        areaId: 0,
        address: ''
      }
    }
  },
  computed: {},
  mounted() {
    this.initPage()
    this.initPhone()
  },
  methods: {
    initPage() {
      const self = this
      baseInfo().then(res => {
        if (res && res.success) {
          if (res.data) {
            self.form = res.data
            if (!self.$isEmpty(res.data.headPicture)) {
              self.headPicture = self.$resUrl(res.data.headPicture)
            }
            if (self.$isEmpty(res.data.name)) {
              self.form.name = ''
            }
            if (self.$isEmpty(res.data.nickName)) {
              self.form.nickName = ''
            }
            if (self.$isEmpty(res.data.age)) {
              self.form.age = 0
            }
            if (self.$isEmpty(res.data.job)) {
              self.form.job = ''
            }
            if (res.data.memberLevelId === 1) {
              self.role = '加盟商'
            } else if (res.data.memberLevelId === 2) {
              self.role = '业务员'
            } else {
              self.role = '普通消费者'
            }
            self.initCity(res.data.provinceId, res.data.cityId, res.data.areaId)
          }
        }
      })
    },
    initPhone() {
      if (Storage.localGet('phone') !== '') {
        this.phone = Storage.localGet('phone')
      }
    },
    initCity(oProvinceId, oCityId, oAreaId) {
      let op = []
      let oc = []
      let oa = []
      let opChildren = []
      let ocChildren = []
      const _this = this
      // ---省---
      if (op === 0) {
        return
      }
      op = city.filter(item => {
        return item.value === oProvinceId
      })
      if (op !== 0) {
        if (op[0]) {
          if (op[0].children.length > 0) {
            opChildren = op[0].children
            _this.province = op[0].text
          }
        }
      }
      // ---市---

      if (opChildren) {
        oc = opChildren.filter(item => {
          return item.value === oCityId
        })
      }

      if (oc) {
        if (oc[0]) {
          if (oc[0].children) {
            ocChildren = oc[0].children
            _this.city = oc[0].text
          }
        }
      }
      // ---区---

      if (ocChildren) {
        oa = ocChildren.filter(item => {
          return item.value === oAreaId
        })
      }

      if (oa) {
        if (oa[0]) {
          _this.area = oa[0].text
        }
      }
    },
    // 申请成为业务员
    applySalesman() {
      const name = this.form.name
      if (this.form.name === 'undefined' || this.form.name === '') {
        Toast.warn('请输入姓名')
        return
      }
      if (this.isRequestApplySalesman) {
        this.isRequestApplySalesman = false
        joinSalesman(name).then(res => {
          if (res && res.success) {
            Toast.success('操作成功')
            this.isRequestApplySalesman = true
          } else {
            Toast.fail(res.msg)
            this.isRequestApplySalesman = true
          }
        })
      }
    },
    // 申请成为加盟商
    applyFranchisee() {
      this.$router.push({ path: '/Personal/Setting/Form/Franchisee' })
    },
    // cityOnConfirm(value, i) {
    //   this.province = value[0]
    //   this.city = value[1]
    //   this.area = value[2]
    //   this.showPicker = false
    //   let pickerValue = this.$refs.pickerValue
    //   var p = pickerValue.getColumnValues(0)
    //   var c = pickerValue.getColumnValues(1)
    //   var s = pickerValue.getColumnValues(2)

    //   this.form.provinceId = p[i[0]].value
    //   this.form.cityId = c[i[1]].value
    //   this.form.areaId = s[i[2]].value
    // },
    btnOnConfirm() {
      // 非空验证
      const _this = this
      if (this.form.nickName === '' || this.form.nickName === 'null') {
        Toast.text('请输入用户名')
        return
      }
      if (this.form.name === '' || this.form.name === 'null') {
        Toast.text('请输入姓名')
        return
      }
      if (this.form.age === '' || this.form.age === 0) {
        Toast.text('请输入年龄')
        return
      }
      if (!this.isAge(_this.form.age)) {
        Toast.text('请输入正确年龄')
        return
      }
      if (this.form.job === '' || this.form.job === 'null') {
        Toast.text('请输入职业')
        return
      }
      // if (this.province === '' || this.city === '' || this.area === '') {
      //   Toast.text('请选择地址')
      //   return
      // }
      if (this.form.address === '' || this.form.address === 'null') {
        Toast.text('请输入地址')
        return
      }

      // 接口
      this.form.age = parseInt(this.form.age)
      if (this.isRequest) {
        this.isRequest = false
        edit(this.form).then(res => {
          if (res && res.success) {
            Toast.success('提交成功')
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
            this.isRequest = true
          } else {
            Toast.fail(res.msg)
            this.isRequest = true
          }
        })
      }
    },
    // 年龄判断
    isAge(str) {
      var age = parseInt(str)
      if (age <= 0 || age >= 130) {
        return false
      } else {
        return age
      }
    },
    // 输入字符标点/特殊符号/空格处理
    onBlur() {
      this.form.name = this.$noSpecialTxt(this.form.name)
      this.form.name = this.$noSpace(this.form.name)
    },
    onBlurNick() {
      this.form.nickName = this.$noSpecialTxt(this.form.nickName)
      this.form.nickName = this.$noSpace(this.form.nickName)
    },
    beforeRead(file) {
      const regex = /(.jpg|.jpeg|.png|.bmp)$/
      if (!regex.test(file.type)) {
        Toast.fail('图片格式不支持上传')
        return false
      } else {
        return true
      }
    },
    // 头像上传
    afterRead(file) {
      this.loading = Toast.loading('头像上传中...', {
        cover: false
      })
      uploadAvatarImg(file.file).then(res => {
        if (res.success) {
          this.loading.hide()
          this.headPicture = this.$resUrl(res.data.url)
          this.form.headPicture = res.data.url
          setAvatar(res.data.url).then(res => {
            if (res && res.success) {
              Toast.success('头像设置成功')
            } else {
              Toast.fail('头像设置失败')
            }
          })
        } else {
          this.loading.hide()
          Toast.fail('头像选择失败')
        }
      })
    },
    onOversize() {
      Toast.fail('文件大小不能超过 5M')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/index.scss';
// 单选按钮
.nut-radiogroup {
  box-sizing: border-box;
  display: flex;
  padding-left: 80px;
  padding-right: 30px;
  justify-content: space-between;

  .nut-radio {
    margin: 0;
  }

  ::v-deep input::after {
    background: $primary-color;
  }

  ::v-deep .nut-radio.nut-radio-size-base input {
    width: 18px;
    height: 18px;
  }

  ::v-deep .nut-radio.nut-radio-size-base .nut-radio-label {
    font-size: 14px;
  }

  ::v-deep .nut-radio-ani {
    background-image: none;
    background-color: #fff;
    border-width: 4px;
  }

  ::v-deep .nut-radio input:checked {
    border: 4px solid $primary-color-light;
    background: none;
    -webkit-box-shadow: 0 1.0666666666667vw 1.6vw 0 rgba(249, 188, 56, 0.15);
    box-shadow: 0 1.0666666666667vw 1.6vw 0 rgba(249, 188, 56, 0.15);
  }
}

// 提交按钮
::v-deep .nut-button.circle {
  border-radius: 50px;
  height: 40px;
  line-height: 40px;
}

::v-deep .nut-textinput-label {
  width: 60px;
  text-align-last: justify;
  text-align: justify;
  text-justify: distribute-all-lines; // 这行必bai加，兼容ie浏览器
}

::v-deep .nut-textinput input {
  padding: 0 0 0 20px;
}

::v-deep .nut-button {
  width: 100%;
  background: $primary-color;
  height: 34px;
  line-height: 34px;
  border-radius: 5px;
  -webkit-appearance: none;
  padding: 0;
}

//图片上传
::v-deep .nut-imagepicker .img-list .img-item:last-child {
  border-radius: 40px;
  overflow: hidden;
}

::v-deep .nut-imagepicker .img-list .add-icon {
  border-radius: 40px;
  overflow: hidden;
  border: 1px solid $primary-color-light;
}

::v-deep .nut-imagepicker .img-list .add-icon i {
  color: $primary-color-light;
}

.content {
  width: 100vw;
  height: auto;
  box-sizing: border-box;
  padding: 20px 0px 80px 0px;
  overflow: hidden;

  .wrap-form {
    width: 100%;
    min-height: 0;
    height: auto;
    background: #ffffff;
    box-sizing: border-box;
    padding: 20px 18px;

    ul {
      display: block;
      width: 100%;
      height: 100%;

      li {
        width: 100%;
        height: 46px;
        line-height: 46px;
        box-sizing: border-box;
        font-size: 14px;
        position: relative;
        &::after {
          @extend %border-bottom;
        }
        &.my-age {
          .my-lable-content {
            background-color: #ffffff;
          }
        }

        .my-row-portrait {
          width: 100%;
          height: 45px;
          position: absolute;
          left: 0;
          top: 0;

          img {
            width: 43px;
            height: 43px;
            border-radius: 43px;
            position: absolute;
            right: 30px;
          }

          .icon-right {
            position: absolute;
            right: 0px;
          }
        }

        .my-lable {
          position: absolute;
          left: 0;
          width: 60px;
          text-align-last: justify;
          text-align: justify;
          text-justify: distribute-all-lines; // 这行必加，兼容ie浏览器
        }

        .my-lable-content {
          margin: 0;
          padding: 0 0 0 80px;
          color: #333333;
          font-size: 14px;
          background: #f3f2f0;
          display: block;
          width: 100%;
          height: 44px;
          float: left;
          box-sizing: border-box;
          .txt-age {
            border: none;
            width: 100%;
            margin: 0;
            padding: 0;
            height: 100%;
            line-height: 100%;
            color: #333333;
            font-size: 14px;
          }
        }

        .avator-img {
          width: 45px;
          height: 45px;
          position: absolute;
          right: 25px;
          overflow: hidden;
          bottom: 2px;
          border-radius: 45px;
          overflow: hidden;
          border: 1px solid #dfc99d;
          text-align: center;
          line-height: 45px;
          .img-wrap {
            width: 45px;
            height: 45px;
            border-radius: 45px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .avator {
            width: 45px;
            height: 45px;
            border-radius: 40px;
            overflow: hidden;
          }

          .icon-user {
            font-size: 30px;
            color: #ffffff;
          }
        }

        .icon-right {
          position: absolute;
          right: 0;
        }

        .area {
          width: 100%;
          height: 100%;
          padding: 0 0 0 80px;
          display: flex;
          justify-content: space-around;
          box-sizing: border-box;
          margin: 0;

          span {
            display: block;
            width: auto;
            max-width: 33.3%;
            float: left;
            color: #666666;
            font-size: 14px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      li:nth-last-child(1) {
        border-bottom: none;
      }

      .role {
        min-height: 46px;
        height: auto;
        overflow: hidden;
      }
      .not-edit {
        .my-lable {
          left: 3px;
          width: 57px;
        }
        .area {
          background: #f3f2f0;
        }
      }
    }
  }

  .btn-wrap {
    width: 100%;
    height: 67px;
    box-sizing: border-box;
    padding: 27px 45px;
  }
}
</style>
